import { render, staticRenderFns } from "./FormMediumProtocol.vue?vue&type=template&id=2a342de0"
import script from "./FormMediumProtocol.vue?vue&type=script&lang=js"
export * from "./FormMediumProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports